(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:request', async (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      return; 
    }

    // Cancel default cart addition processing
    event.preventDefault();

    try {
      // Convert FormData to array format (expected by AddToCartFlyout)
      const formData = event.detail.form;
      const formDataArray = [];
      for (let [key, value] of formData.entries()) {
        formDataArray.push({ name: key, value: value });
      }

      const submitButton = document.querySelector('button[type="submit"], input[type="submit"]');
      
        const addToCartFlyout = new window.AddToCartFlyout(formDataArray, {
          atcButton: submitButton,
          settings: {
            moneyFormat: window.SHOP_MONEY_FORMAT
          }
        });

        // Wait for AddToCartFlyout completion and return actual response data
        const handleComplete = (completeEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.resolve(completeEvent.detail.responseData);
        };

        const handleError = (errorEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.reject(errorEvent.detail.error);
        };

        document.addEventListener('addToCartFlyout:complete', handleComplete);
        document.addEventListener('addToCartFlyout:error', handleError);

    } catch (error) {
      console.error('AddToCartFlyout error:', error);
      event.detail.reject(error);
    }
  });

  document.addEventListener('product-form:cart:navigate', (event) => {
    if (!window.CART_REDIRECTION_ENABLED) {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      window.location.href = window.Theme.routes.cart_url;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oase-albanian-culture-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('oase-text-quotes')) {
  customElements.define('oase-text-quotes', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.querySelector('[data-oase-history-back]').addEventListener('click', event => {
        if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || window.history.length <= 1) return;
        event.preventDefault();
        window.history.back();
      }, { signal });
      this.cards = JSON.parse(this.querySelector('[data-cards]').textContent);
      this.frame = this.querySelector('[data-frame]');
      this.quoteText = this.querySelector('[data-quote-text]');
      this.authorText = this.querySelector('[data-quote-author]');
      this.counter = this.querySelector('[data-count]');
      this.toggle = this.querySelector('[data-toggle]');
      this.index = 0;
      this.interval = Math.max(4000, Number(this.dataset.interval) || 20000);
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.visible = true;
      this.querySelector('[data-controls]').hidden = false;
      this.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => {
        this.show(this.index + Number(button.dataset.step), true);
      }, { signal }));
      this.toggle.addEventListener('click', () => {
        this.paused = !this.paused;
        this.updateControls();
        this.schedule();
      }, { signal });
      this.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.show(this.index + (event.key === 'ArrowLeft' ? -1 : 1), true);
      }, { signal });
      document.addEventListener('visibilitychange', () => this.schedule(), { signal });
      this.motion.addEventListener('change', event => {
        if (event.matches) this.paused = true;
        this.updateControls();
        this.schedule();
      }, { signal });
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.schedule();
      }, { threshold: 0.15 });
      this.observer.observe(this);
      this.updateControls();
      this.show(0);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
    }
    updateControls() {
      this.toggle.textContent = this.paused ? this.dataset.play : this.dataset.pause;
      this.toggle.setAttribute('aria-pressed', String(this.paused));
      this.frame.setAttribute('aria-live', this.paused ? 'polite' : 'off');
    }
    schedule() {
      clearTimeout(this.timer);
      if (!this.isConnected || this.paused || !this.visible || document.hidden || this.cards.length < 2) return;
      this.timer = setTimeout(() => this.show(this.index + 1), this.interval);
    }
    show(index, manual = false) {
      clearTimeout(this.timer);
      if (!this.isConnected || !this.cards.length) return;
      index = (index + this.cards.length) % this.cards.length;
      if (manual) { this.paused = true; this.updateControls(); }
      const card = this.cards[index];
      const quote = card.quote;
      this.quoteText.textContent = quote;
      this.authorText.textContent = card.author;
      this.frame.setAttribute('cite', card.source);
      this.frame.dataset.length = quote.length > 170 ? 'longest' : quote.length > 110 ? 'long' : 'normal';
      this.index = index;
      this.counter.textContent = (index + 1) + ' / ' + this.cards.length;
      this.dataset.index = String(index);
      this.schedule();
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oase-bookstore-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
const ANCHOR_DAY = Math.floor(Date.UTC(2026, 8, 15) / 86400000);
function zurichDayIndex(date = new Date()) {
  const parts = new Intl.DateTimeFormat('en-CA', {timeZone:'Europe/Zurich',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(date);
  const value = type => Number(parts.find(part => part.type === type).value);
  return Math.floor(Date.UTC(value('year'), value('month') - 1, value('day')) / 86400000) - ANCHOR_DAY;
}
function wrapIndex(day, count) { return count > 0 ? ((day % count) + count) % count : -1; }
function availableBookIndex(day, count, available) {
  const start = wrapIndex(day, count);
  for (let offset = 0; offset < count; offset += 1) {
    const index = (start + offset) % count;
    if (available.has(index)) return index;
  }
  return -1;
}

(() => {
  const instances = new WeakMap();
  function mount(root) {
    if (instances.has(root)) return;
    const quoteHost = root.querySelector('[data-daily-quote]');
    const bookHost = root.querySelector('[data-daily-book]');
    const bookPanel = root.querySelector('[data-daily-book-panel]');
    const templates = root.querySelector('[data-daily-templates]');
    if (!quoteHost || !bookHost || !bookPanel || !templates) return;
    let alive = true;
    let pending = null;
    let pendingUpdate = null;
    let currentDay = Number(root.dataset.dayIndex);
    let refreshedDay = currentDay;
    let failedAttempts = 0;
    let retryAt = 0;
    const abort = new AbortController();
    const interacting = () => quoteHost.contains(document.activeElement) || bookHost.contains(document.activeElement);
    function updateLanguage(language) {
      root.dataset.dailyLanguage = language;
      quoteHost.setAttribute('lang', language);
      bookHost.setAttribute('lang', language);
      root.querySelectorAll('[data-daily-quote-label], [data-daily-book-label]').forEach(label => {
        const text = label.dataset[language === 'sq' ? 'labelSq' : 'labelDe'];
        if (text !== undefined) label.textContent = text;
        label.setAttribute('lang', language);
      });
    }
    function applyPending() {
      if (!pendingUpdate || interacting() || document.hidden || !alive) return;
      const fresh = pendingUpdate;
      const freshTemplates = fresh.querySelector('[data-daily-templates]');
      templates.replaceChildren(...Array.from(freshTemplates.childNodes, node => node.cloneNode(true)));
      root.dataset.bookCount = fresh.dataset.bookCount;
      root.dataset.quoteCount = fresh.dataset.quoteCount;
      bookHost.dataset.bookIndex = '';
      quoteHost.dataset.quoteIndex = '';
      quoteHost.dataset.quoteLanguage = '';
      pendingUpdate = null;
      show(zurichDayIndex());
    }
    function show(day) {
      const books = new Map(Array.from(templates.querySelectorAll('[data-book-index]'), template => [Number(template.dataset.bookIndex), template]));
      const index = availableBookIndex(day, Number(root.dataset.bookCount), new Set(books.keys()));
      const book = books.get(index);
      const language = book?.dataset.bookLanguage === 'sq' ? 'sq' : 'de';
      const quoteIndex = wrapIndex(day, Number(root.dataset.quoteCount));
      const quote = templates.querySelector(`[data-quote-index="${quoteIndex}"][data-quote-language="${language}"]`);
      if (quote && (quoteHost.dataset.quoteIndex !== quote.dataset.quoteIndex || quoteHost.dataset.quoteLanguage !== language)) {
        quoteHost.replaceChildren(quote.content.cloneNode(true));
        quoteHost.dataset.quoteIndex = quote.dataset.quoteIndex;
        quoteHost.dataset.quoteLanguage = language;
      }
      if (book && (bookHost.dataset.bookIndex !== String(index) || bookHost.getAttribute('lang') !== language)) {
        bookHost.replaceChildren(book.content.cloneNode(true));
        bookHost.dataset.bookIndex = String(index);
      }
      bookPanel.hidden = index < 0;
      updateLanguage(language);
      currentDay = day;
      root.dataset.dayIndex = String(day);
    }
    async function refresh(day) {
      if (pending) return;
      pending = (async () => {
        let succeeded = false;
        try {
          const url = new URL(window.location.href);
          url.hash = '';
          url.searchParams.set('section_id', root.dataset.sectionId);
          url.searchParams.set('oase_day', String(day));
          const response = await fetch(url, {credentials:'same-origin',cache:'no-store',signal:abort.signal});
          if (!response.ok) return;
          const page = new DOMParser().parseFromString(await response.text(), 'text/html');
          const fresh = page.querySelector('[data-obr-daily]');
          const freshTemplates = fresh?.querySelector('[data-daily-templates]');
          if (!alive || !freshTemplates) return;
          pendingUpdate = fresh;
          refreshedDay = day;
          failedAttempts = 0;
          succeeded = true;
          applyPending();
        } catch (error) {
          if (error.name !== 'AbortError' && alive && !interacting()) show(zurichDayIndex());
        } finally {
          pending = null;
          if (!succeeded && alive) {
            failedAttempts += 1;
            retryAt = Date.now() + Math.min(60000 * (2 ** failedAttempts), 300000);
          }
        }
      })();
    }
    function check() {
      if (!alive || document.hidden) return;
      applyPending();
      const day = zurichDayIndex();
      if (interacting()) return;
      if (day !== currentDay) {
        failedAttempts = 0;
        retryAt = 0;
        show(day);
      }
      if (day !== refreshedDay && failedAttempts < 3 && Date.now() >= retryAt) refresh(day);
    }
    const timer = window.setInterval(check, 60000);
    document.addEventListener('visibilitychange', check);
    window.addEventListener('pageshow', check);
    const focusChanged = () => queueMicrotask(check);
    root.addEventListener('focusout', focusChanged);
    instances.set(root, () => {
      alive = false;
      abort.abort();
      window.clearInterval(timer);
      document.removeEventListener('visibilitychange', check);
      window.removeEventListener('pageshow', check);
      root.removeEventListener('focusout', focusChanged);
      instances.delete(root);
    });
    if (!interacting()) show(currentDay);
    else updateLanguage(bookHost.getAttribute('lang') === 'sq' ? 'sq' : 'de');
    check();
  }
  function start(scope = document) {
    if (scope.matches?.('[data-obr-daily]')) mount(scope);
    scope.querySelectorAll('[data-obr-daily]').forEach(mount);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(), {once:true});
  else start();
  document.addEventListener('shopify:section:load', event => start(event.target));
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.matches?.('[data-obr-daily]')) instances.get(event.target)?.();
    event.target.querySelectorAll('[data-obr-daily]').forEach(root => instances.get(root)?.());
  });
})();

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oase-breadcrumb"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
  if (!(event.target instanceof Element)) return;
  const link = event.target.closest('[data-oase-history-back]');
  if (!link || window.history.length <= 1) return;
  event.preventDefault();
  window.history.back();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oase-collection-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('oase-text-quotes')) {
  customElements.define('oase-text-quotes', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.querySelector('[data-oase-history-back]').addEventListener('click', event => {
        if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || window.history.length <= 1) return;
        event.preventDefault();
        window.history.back();
      }, { signal });
      this.cards = JSON.parse(this.querySelector('[data-cards]').textContent);
      this.frame = this.querySelector('[data-frame]');
      this.quoteText = this.querySelector('[data-quote-text]');
      this.authorText = this.querySelector('[data-quote-author]');
      this.counter = this.querySelector('[data-count]');
      this.toggle = this.querySelector('[data-toggle]');
      this.index = 0;
      this.interval = Math.max(4000, Number(this.dataset.interval) || 20000);
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.visible = true;
      this.querySelector('[data-controls]').hidden = false;
      this.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => {
        this.show(this.index + Number(button.dataset.step), true);
      }, { signal }));
      this.toggle.addEventListener('click', () => {
        this.paused = !this.paused;
        this.updateControls();
        this.schedule();
      }, { signal });
      this.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.show(this.index + (event.key === 'ArrowLeft' ? -1 : 1), true);
      }, { signal });
      document.addEventListener('visibilitychange', () => this.schedule(), { signal });
      this.motion.addEventListener('change', event => {
        if (event.matches) this.paused = true;
        this.updateControls();
        this.schedule();
      }, { signal });
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.schedule();
      }, { threshold: 0.15 });
      this.observer.observe(this);
      this.updateControls();
      this.show(0);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
    }
    updateControls() {
      this.toggle.textContent = this.paused ? this.dataset.play : this.dataset.pause;
      this.toggle.setAttribute('aria-pressed', String(this.paused));
      this.frame.setAttribute('aria-live', this.paused ? 'polite' : 'off');
    }
    schedule() {
      clearTimeout(this.timer);
      if (!this.isConnected || this.paused || !this.visible || document.hidden || this.cards.length < 2) return;
      this.timer = setTimeout(() => this.show(this.index + 1), this.interval);
    }
    show(index, manual = false) {
      clearTimeout(this.timer);
      if (!this.isConnected || !this.cards.length) return;
      index = (index + this.cards.length) % this.cards.length;
      if (manual) { this.paused = true; this.updateControls(); }
      const card = this.cards[index];
      const quote = card.quote;
      this.quoteText.textContent = quote;
      this.authorText.textContent = card.author;
      this.frame.setAttribute('cite', card.source);
      this.frame.dataset.length = quote.length > 170 ? 'longest' : quote.length > 110 ? 'long' : 'normal';
      this.index = index;
      this.counter.textContent = (index + 1) + ' / ' + this.cards.length;
      this.dataset.index = String(index);
      this.schedule();
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
